import { Link } from 'react-router-dom'

// Placeholder sponsored-placement slot. Visibly signals to forwarders/carriers that they can list
// here — the "sold" state renders real advertiser content once we wire it.
export function SponsorSlot({ context }: { context?: string }) {
  return (
    <Link
      to="/advertise"
      className="block rounded-lg border border-dashed border-border-strong bg-surface-0 px-4 py-3 text-sm text-muted hover:border-signal hover:text-ink transition-colors"
    >
      <span className="font-mono text-xs uppercase tracking-wide text-signal">Sponsored</span>
      <span className="ml-2">
        Are you a forwarder or carrier{context ? ` on ${context}` : ''}? Feature your rate here →
      </span>
    </Link>
  )
}
